export class Search {

  public constructor() {
    $('[data-search]').on('keyup', (e) => {
      this.find($('input[data-search]').val() as string);
    })
  }

  private find(value: string) {
    $("[data-game]").each((i, el) => {
      const searchAttrValue = $(el).data('name');
      if (value == "") {
        this.show($(el));
      } else {
        if (searchAttrValue.toLowerCase().indexOf(value.toLowerCase()) < 0) {
          this.hide($(el));
        } else {
          this.show($(el));
        }
      }

      this.hideSections();
    });
  }

  private hideSections() {
    $('.gameserver-group').each((index, el) => {
      if ($(el).find('.game').not('[data-hidden]').length === 0) {
        $(el).hide();
      } else {
        $(el).show();
      }
    });
  }

  private show(el: JQuery) {
    el.show().removeAttr('data-hidden');
  }

  private hide(el: JQuery) {
    el.hide().attr('data-hidden', '1');
  }
}
